import { type PropsWithChildren, useEffect } from 'react';
import { useNavigate, useRouteLoaderData } from 'react-router';

import { type loader } from '../_layout';

export function AuthRequired({ children }: PropsWithChildren<unknown>) {
  const navigate = useNavigate();
  const user = useRouteLoaderData<typeof loader>('routes/events+/_layout');

  if (user === undefined) {
    console.warn(
      'Route loader data was undefined. This might mean that the AuthRequired component is being used outside of a route that has the loader it needs.',
    );
  }

  useEffect(() => {
    if (!user) {
      navigate(`/login?redirectTo=${encodeURIComponent(window.location.pathname)}`);
    }
  }, [user, navigate]);

  if (!user) {
    return null;
  }

  return children;
}
